import { Dispatch } from 'redux';
import { BaseAction, BaseActionCreator } from 'sagas/base/base.types';

export function dispatchWithPromise<T extends BaseAction>(dispatch: Dispatch, action: BaseActionCreator<T>, payload: T['payload']) {
    return new Promise((resolve, reject) => dispatch<T>(action(payload, resolve, reject)));
}
